<template>
  <profile-card header-color="blue" class="search-sidebar">
    <template slot="header">
      <div class="card-icon">
        <md-icon>settings</md-icon>
      </div>
    </template>
    <template slot="content">
      <div class="info-wrap">
        <md-field v-if="tab == 'industry' || tab == 'market_area'">
          <label>Keyword Search</label>
          <md-input @keyup.enter="searchIndustriesByInput" v-model="search" aria-label="keyword search"
            placeholder="Search..." type="text">
          </md-input>
          <div @click="searchIndustriesByInput">
            <md-icon>search</md-icon>
          </div>
        </md-field>

        <div class="alert" v-if="notAvailable">
          <span class="closebtn" @click="closeAlert">&times;</span>
          Chosen favorite is unavailable with provided information
        </div>
        <ul v-if="loaded" class="favorite-list">
          <li v-for="(favorite, index) in favorites" :key="index" class="favorite-list-item">
            <div class="list-item-head">
              <span class="icon mr-5">
                <md-icon @click.native="
                  chooseFavorite(favorite.data, favorite.search1)
                  " class="add-item">playlist_add</md-icon>
                {{
                  tab === "industry"
                  ? favorite.search1
                  : getName(favorite.search1)
                }}
              </span>
              <!--<span class="title">
              {{tab === 'industry' ? favorite.data : ''}}
              </span>-->
              <span class="actions ml-5">
                <md-icon @click.native="removeFavorite(favorite.id, index)" class="delete-item">delete</md-icon>
              </span>
            </div>
            <!--
            <div class="list-item-body">
              {{
                tab === 'industry'
                  ? favorite.search1
                  : getName(favorite.search1)
              }}
            </div>-->
          </li>
        </ul>
      </div>
    </template>
  </profile-card>
</template>

<script>
import { ProfileCard } from "@/components";
import axios from "axios";
import { debounce } from "lodash";

export default {
  name: "sidebar-search",
  props: {
    title: {
      type: String,
    },
    tab: {
      type: String,
    },
  },
  components: { ProfileCard },
  data() {
    return {
      route: null,
      notAvailable: false,
      search: "",
      favorites: undefined,
      loaded: false,
      debounceHandlerIndustry: debounce(
        () => this.$store.commit("SET_SEARCH_INPUT_INDUSTRY", this.search),
        3000
      ),
      debounceHandlerMarketArea: debounce(
        () => this.$store.commit("SET_SEARCH_INPUT_MARKET_AREA", this.search),
        3000
      ),
    };
  },
  methods: {
    closeAlert: function () {
      this.notAvailable = false;
    },
    getName: function (name) {
      return name.split("[")[0];
    },
    getData: function (name) {
      if (name) {
        return name.split("[")[1].split("]")[0];
      }
    },
    sendIndustryLoad: function (isLoading) {
      this.$emit("load-industry", { isLoading: isLoading });
    },
    sendAreaLoad: function (isLoading) {
      this.$emit("load-area", { isLoading: isLoading });
    },
    chooseInput: function () {
      if (this.tab === "industry") {
        if (this.search) {
          this.sendIndustryLoad(true);
          this.$store.commit("SET_SEARCH_INDUSTRIES", null);
          this.$store.commit("SET_SEARCH_LOADING_INDUSTRY", true);
          this.debounceInputIndustry();
        } else {
          this.$store.commit("SET_SEARCH_LOADING_INDUSTRY", false);
          this.$store.commit("SET_SEARCH_INPUT_INDUSTRY", "");
        }
      } else if (this.tab === "market_area") {
        if (this.search) {
          this.sendAreaLoad(true);
          this.$store.commit("SET_SEARCH_MARKET_AREAS", null);
          this.$store.commit("SET_SEARCH_LOADING_MARKET_AREA", true);
          this.debounceInputMarketArea();
        } else {
          this.$store.commit("SET_SEARCH_LOADING_MARKET_AREA", false);
          this.$store.commit("SET_SEARCH_INPUT_MARKET_AREA", "");
        }
      }
    },
    debounceInputIndustry: function () {
      this.debounceHandlerIndustry();
    },
    debounceInputMarketArea: function () {
      this.debounceHandlerMarketArea();
    },
    removeFavorite: async function (id, index) {
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      this.favorites.splice(index, 1);

      await axios.post(
        process.env.VUE_APP_API_BASE_URL + "/user/favorites/delete",
        {},
        {
          params: {
            session_id: currentSession,
            favoriteID: id,
          },
        }
      );
    },
    findMarket: function (arr, item) {
      return arr.some((market) => market.includes(item));
    },
    chooseFavorite: async function (data, title) {
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      if (this.tab === "industry") {
        this.$store.commit("SET_INDUSTRY", title);

        await axios
          .post(
            process.env.VUE_APP_API_BASE_URL + this.route,
            {},
            {
              params: {
                session_id: currentSession,
                industry: data,
                profile_id: this.profileId ? this.profileId : "0",
                type:
                  this.$store.getters.type === "Industry firms" ? "if" : "spif",
              },
            }
          )
          .then((res) => {
            if (res.hasOwnProperty("data") && res.data.error) {
              this.$store.commit("SET_ERROR_BIT", true);
              this.$store.commit(
                "SET_ERROR_INFO",
                "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + ${this.route} <br>`
              );
              throw new Error(
                "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
              );
            }
            const { id } = res.data;
            this.$store.commit("SET_PROFILE_ID", id);
          });
      } else if (this.tab === "market_area") {
        let temp = [];
        let availableMarkets = [];
        let trimmedTitle = this.getName(title).trim();

        await axios
          .get(process.env.VUE_APP_API_BASE_URL + "/info/areas", {
            params: {
              type: "if",
              industry: this.getData(this.industry),
            },
          })
          .then((res) => {
            if (res.hasOwnProperty("data") && res.data.error) {
              this.$store.commit("SET_ERROR_BIT", true);
              this.$store.commit(
                "SET_ERROR_INFO",
                "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/areas" <br>`
              );
              throw new Error(
                "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
              );
            }
            temp = res.data.data;
            temp.forEach((market) => {
              availableMarkets.push(market.area);
            });
          });

        if (
          this.findMarket(availableMarkets, trimmedTitle) ||
          trimmedTitle === "US"
        ) {
          this.$store.commit("SET_MARKET_AREA", title);
          await axios
            .post(
              process.env.VUE_APP_API_BASE_URL + this.route,
              {},
              {
                params: {
                  session_id: currentSession,
                  area: parseInt(data),
                  profile_id: this.profileId ? this.profileId : "0",
                  type:
                    this.$store.getters.type === "Industry firms"
                      ? "if"
                      : "spif",
                },
              }
            )
            .then((res) => {
              if (res.hasOwnProperty("data") && res.data.error) {
                this.$store.commit("SET_ERROR_BIT", true);
                this.$store.commit(
                  "SET_ERROR_INFO",
                  "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode +
                  `<br> ${process.env.VUE_APP_API_BASE_URL} + ${this.route} <br>`
                );
                throw new Error(
                  "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode
                );
              }
              const { id } = res.data;
              this.$store.commit("SET_PROFILE_ID", id);
            });
        } else {
          this.notAvailable = true;
        }
      } else if (this.tab === "sales_class") {
        let availableSales = [];
        let temp = [];
        let trimmedTitle = this.getName(title).trim();

        await axios
          .get(process.env.VUE_APP_API_BASE_URL + "/info/sales_classes", {
            params: {
              type: "if",
              industry: this.getData(this.industry),
            },
          })
          .then((res) => {
            if (res.hasOwnProperty("data") && res.data.error) {
              this.$store.commit("SET_ERROR_BIT", true);
              this.$store.commit(
                "SET_ERROR_INFO",
                "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/sales_classes" <br>`
              );
              throw new Error(
                "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
              );
            }
            this.temp = res.data.data;
            this.temp.forEach((sales) => {
              availableSales.push(sales.name);
            });
          });

        if (trimmedTitle === "Large > $25m") {
          trimmedTitle = "Large  > $25m";
        }

        if (trimmedTitle === "Industrywide") {
          trimmedTitle = "industrywide";
        }

        if (availableSales.includes(trimmedTitle)) {
          this.$store.commit("SET_SALES_CLASS", title);

          await axios
            .post(
              process.env.VUE_APP_API_BASE_URL + this.route,
              {},
              {
                params: {
                  session_id: currentSession,
                  sales_class: data,
                  profile_id: this.profileId ? this.profileId : "0",
                  type:
                    this.$store.getters.type === "Industry firms"
                      ? "if"
                      : "spif",
                },
              }
            )
            .then((res) => {
              if (res.hasOwnProperty("data") && res.data.error) {
                this.$store.commit("SET_ERROR_BIT", true);
                this.$store.commit(
                  "SET_ERROR_INFO",
                  "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode +
                  `<br> ${process.env.VUE_APP_API_BASE_URL} + ${this.route} <br>`
                );
                throw new Error(
                  "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode
                );
              }
              const { id } = res.data;
              this.$store.commit("SET_PROFILE_ID", id);
            });
        } else {
          this.notAvailable = true;
        }
      }
    },
    getFavorites: async function () {
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      if (this.tab === "industry") {
        this.$store.dispatch("favorite/getIndustry").then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
              "Server responded with error = True <br> errorCode: " +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/favorites/get" <br>`
            );
            throw new Error(
              "<br>" +
              "Server responded with error = True <br> errorCode: " +
              res.data.errorCode
            );
          }
          this.favorites = res.data.data;
          this.loaded = true;
        });
        this.$store.commit("SET_FAVORITE_INDUSTRIES", this.favorites);
      } else if (this.tab === "market_area") {
        this.$store.dispatch("favorite/getMarketArea").then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
              "Server responded with error = True <br> errorCode: " +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/favorites/get" <br>`
            );
            throw new Error(
              "<br>" +
              "Server responded with error = True <br> errorCode: " +
              res.data.errorCode
            );
          }
          this.favorites = res.data.data;
          this.loaded = true;
        });
        this.$store.commit("SET_FAVORITE_MARKET_AREAS", this.favorites);
      } else if (this.tab === "sales_class") {
        this.$store.dispatch("favorite/getSalesClass").then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
              "Server responded with error = True <br> errorCode: " +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/favorites/get" <br>`
            );
            throw new Error(
              "<br>" +
              "Server responded with error = True <br> errorCode: " +
              res.data.errorCode
            );
          }
          this.favorites = res.data.data;
          this.loaded = true;
        });
        this.$store.commit("SET_FAVORITE_SALES_CLASSES", this.favorites);
      }
    },
    searchIndustriesByInput: async function () {
      let apiData = [];

      if (this.tab === "industry") {
        this.sendIndustryLoad(true);
        this.$store.commit("SET_SEARCH_INDUSTRIES", null);
        this.$store.commit("SET_SEARCH_LOADING_INDUSTRY", true);
        let industries = [];
        let availableIndustries = [];
        let allIndustryData = [];
        if (this.search != null && !!this.search) {
          //availableIndustries
          await axios
            .get(process.env.VUE_APP_API_BASE_URL + "/info/industries", {
              params: {
                type: "if",
                search: this.search,
                industry: this.getData(this.industry) || "0",
                area: parseInt(this.getData(this.marketArea)) || 0,
                sales_class: this.getData(this.salesClass) || "0",
              },
            })
            .then((res) => {
              if (res.hasOwnProperty("data") && res.data.error) {
                this.$store.commit("SET_ERROR_BIT", true);
                this.$store.commit(
                  "SET_ERROR_INFO",
                  "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode +
                  `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/industries" <br>`
                );
                throw new Error(
                  "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode
                );
              }
              apiData = res.data.data;
              apiData.forEach((industry) => {
                availableIndustries.push(
                  `${industry.name} [${industry.bznaics}]`
                );

                industries.push(`${industry.name} [${industry.bznaics}]`);
                allIndustryData.push(industry);
              });
              this.sendIndustryLoad(false);
            });

          let temp = [industries, availableIndustries, allIndustryData];
          this.$store.commit("SET_SEARCH_INDUSTRIES", temp);
        } else {
          this.searchMarketAreasByInput();
        }
      }
    },
    searchMarketAreasByInput: async function () {
      let apiData = [];

      let marketAreas = [];
      let availableMarketAreas = [];
      if (this.search) {
        //availableMarketAreas
        await axios
          .get(process.env.VUE_APP_API_BASE_URL + "/info/areas", {
            params: {
              type: "if",
              search: this.search,
              industry: this.getData(this.industry) || "0",
            },
          })
          .then((res) => {
            if (res.hasOwnProperty("data") && res.data.error) {
              this.$store.commit("SET_ERROR_BIT", true);
              this.$store.commit(
                "SET_ERROR_INFO",
                "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/areas" <br>`
              );
              throw new Error(
                "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
              );
            }
            apiData = res.data.data;
            apiData.forEach((market) => {
              availableMarketAreas.push(`${market.area} [${market.state_id}]`);
              marketAreas.push(`${market.area} [${market.state_id}]`);
            });
            this.sendAreaLoad(false);
          });

        let temp = [marketAreas, availableMarketAreas];
        this.$store.commit("SET_SEARCH_MARKET_AREAS", temp);
      }
    },
  },
  async created() {
    if (this.$route.name === "NewProfile")
      this.route = "/user/search_profiles/if";
    else this.route = "/user/search_reports/if";

    this.$store.commit("SET_SEARCH_INDUSTRIES", null);
    this.$store.commit("SET_SEARCH_MARKET_AREAS", null);
    this.$store.commit("SET_SEARCH_INPUT_INDUSTRY", null);
    this.$store.commit("SET_SEARCH_INPUT_MARKET_AREA", null);
    await this.getFavorites();
  },
  computed: {
    profileId() {
      return this.$store.getters.profileId;
    },
    searchInputIndustry() {
      return this.$store.getters.searchInputIndustry;
    },
    searchInputMarketArea() {
      return this.$store.getters.searchInputMarketArea;
    },
    favoriteIndustries() {
      return this.$store.getters.favoriteIndustries;
    },
    favoriteMarketAreas() {
      return this.$store.getters.favoriteMarketAreas;
    },
    favoriteSalesClasses() {
      return this.$store.getters.favoriteSalesClasses;
    },
    industry() {
      return this.$store.getters.industry;
    },
    marketArea() {
      return this.$store.getters.marketArea;
    },
    salesClass() {
      return this.$store.getters.salesClass;
    },
  },
  watch: {
    industry(newValue, oldValue) {
      this.notAvailable = false;
    },
    marketArea(newValue, oldValue) {
      this.notAvailable = false;
    },
    salesClass(newValue, oldValue) {
      this.notAvailable = false;
    },
    favoriteIndustries(newValue, oldValue) {
      if (this.tab === "industry") {
        this.favorites = this.$store.getters.favoriteIndustries;
      }
    },
    favoriteMarketAreas(newValue, oldValue) {
      if (this.tab === "market_area") {
        this.favorites = this.$store.getters.favoriteMarketAreas;
      }
    },
    favoriteSalesClasses(newValue, oldValue) {
      if (this.tab === "sales_class") {
        this.favorites = this.$store.getters.favoriteSalesClasses;
      }
    },
    searchInputIndustry(newValue, oldValue) {
      //this.searchIndustriesByInput();
    },
    searchInputMarketArea(newValue, oldValue) {
      this.searchMarketAreasByInput();
    },
  },
};
</script>
<style lang="scss">
.alert {
  padding: 20px;
  background-color: #6839dd;
  /* Red */
  color: white;
  margin-bottom: 15px;
  font-weight: bold;
}

.closebtn {
  margin-left: 15px;
  color: white;
  font-weight: bold;
  float: right;
  font-size: 22px;
  line-height: 20px;
  cursor: pointer;
  transition: 0.3s;
}

.closebtn:hover {
  color: black;
}
</style>
